<template>
  <div class="flex flex-col overflow-y-scroll h-svh rtl:text-right" v-show="!preLoading">
    <div class="flex flex-col grow">
      <Header :is-stc="isStc" />
      <MainContent :isHybrid="isHybrid" :is-stc="isStc" :decodedData="decodedData" />
    </div>
    <Footer :is-stc="isStc" :version="appVersion" />
  </div>
  <div v-if="preLoading" class="flex items-center justify-center h-svh font-bold animate-pulse">
    {{ $t('loading') }}
  </div>
</template>

<script setup>
import { computed, onBeforeMount, ref, watchEffect } from 'vue'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'
import MainContent from './components/MainContent.vue'
import {useI18n} from 'vue-i18n'

const appVersion = __APP_VERSION__

const isStc = ref(false)
const isHybrid = ref(false)
const decodedData = ref({})
const preLoading = ref(true)
const isDataFromMobileApp = ref(false)
const { locale } = useI18n()

const isRtl = computed(()=> ['fa'].includes(locale.value))

const updateRtlAttribute = () => {
  document.documentElement.setAttribute('lang', locale.value)
  document.documentElement.setAttribute('dir', isRtl.value ? 'rtl' : 'ltr')
}

onBeforeMount(() => {
  setTimeout(() => {
    preLoading.value = false
  }, 1500)

  const urlParams = new URLSearchParams(window.location.search)
  const encodeDataFromUrl = urlParams.get('settings')
  const encodeDataFromApp = urlParams.get('appSettings')
  if (encodeDataFromUrl) {
    decodedData.value = decodeDataFromQueryParameters(encodeDataFromUrl)
  } else if (encodeDataFromApp) {
    isDataFromMobileApp.value = true
    decodedData.value = decodeDataFromQueryParameters(encodeDataFromApp)
    decodedData.value.isDataFromMobileApp = isDataFromMobileApp.value
  }
  if (urlParams.get('is_stc') === 'true') {
    isStc.value = true
  }
  if (urlParams.get('sg_outside') === 'true') {
    isHybrid.value = true
  }
  updateRtlAttribute()
})

watchEffect(() => {
  updateRtlAttribute()
})

const decodeDataFromQueryParameters = (data) => {
  const base64String = decodeURIComponent(data)
  const jsonString = atob(base64String)

  if (isDataFromMobileApp.value) {
    const params = new URLSearchParams(jsonString)
    const jsonObject = {}

    params.forEach((value, key) => {
      jsonObject[key] = value
    })

    return jsonObject
  } else {
    return JSON.parse(jsonString)
  }
}
</script>